import React from 'react';
import classNames from 'classnames';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Icons } from '../../../components/base/BootstrapComponents';
import CustomButton from '../../../components/base/Button/CustomButton';

export default function HostDeletePopUp(props) {
  const {
    onHide,
    user_ids = [],
    setSelected,
    removeHostByIds,
  } = props;

  const handleRemoveId = id => {
    const nextIds = user_ids.filter(userId => userId !== id);

    if (!nextIds.length) {
      setSelected([]);
      onHide();
      return;
    }

    setSelected(nextIds);
  };

  return (
    <Dialog
      className={classNames('host-popup-delete')}
      onClose={() => { onHide(); }}
      size="xl"
      open
    >
      <DialogTitle
        className="hff-title"
        title={(
          <>
            <div className="hff-title-text f2">{user_ids.length > 1 ? 'Удалить хосты?' : 'Удалить хост?'}</div>
            <div className="hff-close-wrapper">
              <Icons width={14} height={14} customIcon icon="clear" className="hff-close" onClick={onHide} />
            </div>
          </>
        )}
      />
      <DialogContent className="hff-content">
        <div className="delete-description">
          {user_ids.length > 1 ? 'Будут удалены выбранные хосты:' : 'Будет удален выбранный хост:'}
        </div>
        <div className="delete-items">
          {user_ids.map((id, index) => (
            <div key={index} className="delete-item">
              <div className="delete-item-text">{id}</div>
              <Icons
                customIcon
                className="hff-close"
                onClick={() => {
                  handleRemoveId(id);
                }}
                width={14}
                height={14}
                icon="clear"
              />
            </div>
          ))}
        </div>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <CustomButton
          text="Удалить"
          onClick={() => {
            removeHostByIds(user_ids)
              .then(() => {
                onHide();
              })
              .catch(() => {});
          }}
        />
        <CustomButton isCancel text="Отменить" onClick={() => { onHide(); setSelected([]); }} />
      </DialogFooter>
    </Dialog>
  );
}
